/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Group_SettingsInputs */

const en_us2_search_group_settings = /** @type {(inputs: Search_Group_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const pt_br2_search_group_settings = /** @type {(inputs: Search_Group_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

const es_419_search_group_settings = /** @type {(inputs: Search_Group_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

const pt_pt2_search_group_settings = /** @type {(inputs: Search_Group_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definições`)
};

const fr_fr2_search_group_settings = /** @type {(inputs: Search_Group_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglages`)
};

const de_de2_search_group_settings = /** @type {(inputs: Search_Group_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const it_it2_search_group_settings = /** @type {(inputs: Search_Group_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Search_Group_SettingsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_group_settings = /** @type {((inputs?: Search_Group_SettingsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Group_SettingsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_group_settings(inputs)
	if (locale === "es-419") return es_419_search_group_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_search_group_settings(inputs)
	if (locale === "fr-FR") return fr_fr2_search_group_settings(inputs)
	if (locale === "de-DE") return de_de2_search_group_settings(inputs)
	if (locale === "it-IT") return it_it2_search_group_settings(inputs)
	return en_us2_search_group_settings(inputs)
});
export { search_group_settings as "search.group_settings" }